import {Injectable} from '@angular/core';
import {SubscriptionsService} from './subscriptions.service';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    currency: any;

    constructor(public subscriptionsService: SubscriptionsService) {
        const currencyText = localStorage.getItem('currency');
        if (currencyText) {
            const currencyJson = JSON.parse(currencyText);
            if (currencyJson) {
                this.currency = currencyJson;
            }
        }
        this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.currency = currency;
            }
        });
    }

    replaceEuro(string) {
        return string.replace(new RegExp('€', 'g'), this.currency.Symbol).replace(new RegExp('&euro;', 'g'), this.currency.Symbol);
    }
}
